import React from 'react'

export default ({ ...props }) => (
  <svg {...props} width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_1173_4055)'>
      <path
        d='M6.65 14C4.8734 14 3.2039 13.3084 1.9474 12.0526C0.6909 10.7968 0 9.12661 0 7.35071C0 5.57411 0.6916 3.90461 1.9474 2.64811C3.2032 1.39161 4.8734 0.700012 6.65 0.700012C8.4266 0.700012 10.0961 1.39161 11.3526 2.64811C12.6091 3.90461 13.3 5.57411 13.3 7.35071C13.3 9.12731 12.6084 10.7968 11.3526 12.0526C10.0968 13.3084 8.4266 14 6.65 14ZM6.65 1.40001C3.3691 1.40001 0.7 4.06911 0.7 7.35001C0.7 10.6309 3.3691 13.3 6.65 13.3C9.9309 13.3 12.6 10.6309 12.6 7.35001C12.6 4.06911 9.9309 1.40001 6.65 1.40001Z'
        fill='#0D0D0D'
      />
      <path
        d='M5.24998 10.15C5.16038 10.15 5.07078 10.1157 5.00218 10.0478L2.90218 7.94778C2.76568 7.81128 2.76568 7.58938 2.90218 7.45288C3.03868 7.31638 3.26058 7.31638 3.39708 7.45288L5.24928 9.30508L9.90148 4.65288C10.038 4.51638 10.2599 4.51638 10.3964 4.65288C10.5329 4.78938 10.5329 5.01128 10.3964 5.14778L5.49638 10.0478C5.42778 10.1164 5.33818 10.15 5.24858 10.15H5.24998Z'
        fill='#0D0D0D'
      />
    </g>
    <defs>
      <clipPath id='clip0_1173_4055'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
